import { useEffect, useRef, useState } from "react";
import { IUser } from "../../type";
import { update_avatar } from "../../api/user";
import "./index.css";

interface IProps {
  user: IUser;
  onAvatarUpdated: (user: IUser) => void;
  onclkbtn: () => void;
}

export function AvatarEdit(props: IProps) {
  const form_ref = useRef<HTMLFormElement>(null);
  const file_ref = useRef<HTMLInputElement>(null);
  const [previewUrl, setPreviewUrl] = useState<string>(
    (props.user.avatarLink && props.user.avatarLink !== "no-avatar" && "/" + props.user.avatarLink) ||
      "/avatar.png"
  );

  useEffect(() => {
    setPreviewUrl(
      (props.user.avatarLink && props.user.avatarLink !== "no-avatar" && "/" + props.user.avatarLink) ||
        "/avatar.png"
    );
  }, [props.user]);

  const file_change = async () => {
    const file = file_ref.current?.files?.[0];
    if (!file) return;

    const localPreview = URL.createObjectURL(file);
    setPreviewUrl(localPreview);

    if (form_ref.current) {
      const submitBody = new FormData(form_ref.current);
      try {
        const r = await update_avatar(submitBody);
        props.onAvatarUpdated(r.user);
        props.onclkbtn();
      } catch (e) {
        // Если загрузка не удалась — остаемся на шаге выбора аватара.
      } finally {
        URL.revokeObjectURL(localPreview);
      }
    }
  };

  return (
    <section className="section mainPage flex flex-column sectionUser profileEditStep">
      <div className="headerUserEdit flex flex-column editprofile">
        <div className="avatarProfile">
          <img
            src={previewUrl}
            className="avatarProfile-image"
            alt=""
          />
        </div>
        <button
          type="button"
          className="textavAvatarProfile profileEdit-photoButton"
          onClick={() => file_ref.current?.click()}
        >
          Выбрать фотографию
        </button>
        <form ref={form_ref} action="#">
          <input
            ref={file_ref}
            type="file"
            name="input_file"
            id="input_file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={file_change}
          />
        </form>
      </div>
      <div
        className="registration-button"
        onClick={() => {
          props.onclkbtn();
        }}
      >
        Далее
      </div>
    </section>
  );
}
